/**
 * Calculate the square root of a value.
 *
 * For matrices, if you want the matrix square root of a square matrix,
 * use the `sqrtm` function. If you wish to apply `sqrt` elementwise to
 * a matrix M, use `math.map(M, math.sqrt)`.
 *
 * Syntax:
 *
 *    sqrt(x)
 *
 * Examples:
 *
 *    sqrt(25)                // returns 5
 *    sqrt(-4)                // returns NaN (for negative numbers)
 *
 * @param {number} x
 *            Value for which to calculate the square root.
 * @return {number}
 *            Returns the square root of `x`
 */
export function sqrt(x: number): number {
  if (isNaN(x)) {
    return NaN;
  } else if (x >= 0) {
    return Math.sqrt(x);
  } else {
    // For negative numbers, return NaN (simplified version)
    // In the full mathjs implementation, this would return a Complex number
    return NaN;
  }
}
